import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import BackgroundLink from 'images/solutionPage/backgrounds/backgroundLinks.svg';
import { breakpoint } from 'utils/mediaQueries';
import BackgroundLinkTablet from 'images/solutionPage/backgrounds/backgroundLinksTablet.svg';
import { colors } from 'styles';
import BackgroundLinkMobile from 'images/solutionPage/backgrounds/backgroundLinksMobile.svg';

const LinkBackground = styled(Grid)`
  z-index: -1;
  height: 100%;
  width: 100%;
  position: absolute;
  top:0;
  background-image: url("${BackgroundLink}");
  background-size: 100% 100%;
  ${breakpoint.down('md')`
  background: url("${BackgroundLinkTablet}"),linear-gradient(to bottom, #FFF 25%, ${
    colors.shades.grey.light
  } 25%); `}
  ${breakpoint.down('sm')`
   background: url("${BackgroundLinkMobile}"),linear-gradient(to bottom, #FFF 25%, ${
    colors.shades.grey.light
  } 25%);background-repeat: no-repeat;background-size: 100% 100%`};
`;
const LinkBlockBackground = () => {
  return <LinkBackground />;
};
export default LinkBlockBackground;
